<template>
  <div class="pwc-product-list" type="flex" justify="center">
    <product-item
      v-for="p in cProductList"
      :key="p.id"
      :product="p"
      :register="handleRegister"
    />
    <pwc-no-data v-if="cProductList.length === 0" />
    <!-- <pwc-term
      :show.sync="showTermDialog"
      :term="term"
      :confirm="handleConfirm"
    /> -->
  </div>
</template>

<script>
import ProductItem from './ProductItem'
// import PwcTerm from '../../PwcTerm/mobile'
import { logic } from '../common/mixin/logic'
import PwcNoData from '../../NoData'

export default {
  inject: ['home'],
  components: {
    ProductItem,
    PwcNoData
    // PwcTerm
  },
  mixins: [logic]
}
</script>

<style lang="scss" scoped>
.pwc-product-list {
    flex-wrap: wrap;
}
</style>
